<template>
  <v-row>
    <v-col cols="12">
      <p class="primary--text subtitle-1 mb-2 font-weight-bold">
        {{title}}
        <slot />
      </p>
      <v-divider class="primary" />
    </v-col>
  </v-row>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
  },
};
</script>
